import { Button, Flex, Spacer, Text } from '@sendoutcards/quantum-design-ui'

const CUSTOMER_SUPPORT_PHONE = '801-463-3800'

export const UnlockCallRequired = () => {
  const handleCall = () => {
    window.open(`tel:${CUSTOMER_SUPPORT_PHONE}`, '_self')
  }

  return (
    <Flex
      flexDirection="column"
      alignItems="center"
      style={{ maxWidth: '500px', width: '100%' }}
    >
      <Spacer space="x4" />
      <Text type="title" alignment="center" weight="bold">
        Call Required to Unlock
      </Text>
      <Spacer space="x3" />
      <Text type="body" alignment="center">
        For security reasons, your account requires assistance from our customer
        support team to be unlocked. Please call us at the number below and have
        your account information ready.
      </Text>
      <Spacer space="x4" />
      <Flex
        flexDirection="column"
        alignItems="center"
        style={{
          width: '100%',
          padding: '24px',
          backgroundColor: '#F3F4F6',
          borderRadius: '12px',
          border: '1px solid #E5E7EB',
        }}
      >
        <Text type="caption" alignment="center" color="primaryBody">
          Customer Support
        </Text>
        <Spacer space="x2" />
        <Text type="title" alignment="center" weight="bold">
          {CUSTOMER_SUPPORT_PHONE}
        </Text>
        <Spacer space="x2" />
        <Text type="caption" alignment="center">
          Available Monday - Friday
          <br />
          9:00 AM - 5:00 PM MT
        </Text>
      </Flex>
      <Spacer space="x4" />
      <Button onClick={handleCall} fullWidth size="large">
        Call Customer Support
      </Button>
      <Spacer space="x3" />
      <Text type="caption" alignment="center">
        Our support team will verify your identity and help unlock your account.
      </Text>
    </Flex>
  )
}
